import { useParams } from "react-router-dom";
import Fetch from "../Fetch";
import ItemUpdate from "./ItemUpdate";
import { URL, TYPE, ACTION } from "../URL";

export default function FetchItemUpdate() {
    let { id } = useParams();
    return (
        <Fetch
            url={new URL(ACTION.DETAIL, TYPE.ITEM, id, {"to_update" : 1})}
            /* 
            * ItemUpdate 内で useForm を使っているためこのように書く.
            * (Rendered more hooks than during the previous render というエラー対策)
            */
            renderSuccess={(data) => <ItemUpdate data={data.data} />}
        />
    );
}
